/*
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2023-10-10 09:26:28
 * @LastEditors: whaoo
 * @LastEditTime: 2024-01-04 13:42:35
 */
import Vue from 'vue'
import Router from 'vue-router'
import BedList from '@/view/bed_list'
import BedDetail from '@/view/bed_detail'
import BindDevice from '@/view/bind_device'
import DeviceData from '@/view/device_data'
import device_list from '@/view/managePages/device_list'
import all_device_data from '@/view/managePages/all_device_data'
import all_device_data_1 from '@/view/managePages/all_device_data_1'
import login from '@/view/layout/login'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/bedList',
      name: 'bedList',
      component: BedList
    }, {
      path: '/bedDetail',
      name: 'bedDetail',
      component: BedDetail,
    },
    {
      path: "/bindDevice",
      name: 'bindDevice',
      component: BindDevice
    },
    {
      path: "/deviceData",
      name: 'deviceData',
      component: DeviceData
    }
    ,
    {
      path: "/device_list",
      name: 'device_list',
      component: device_list
    }
    ,
    {
      path: "/all_device_data_1",
      name: 'all_device_data_1',
      component: all_device_data_1
    }
    ,{
      path: "/all_device_data",
      name: 'all_device_data',
      component: all_device_data
    }
    ,
    {
      path: "/login",
      name: 'login',
      component: login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js